// src/marketing/adminMarketingApi.ts
import { apiClient } from "@maat/api-base";
var adminMarketingApi = {
  list: async (params) => {
    return apiClient.get("/main/api/admin/marketing/assets", { params });
  },
  get: async (id) => {
    return apiClient.get(`/main/api/admin/marketing/assets/${id}`);
  },
  create: async (data) => {
    return apiClient.post("/main/api/admin/marketing/assets", data);
  },
  update: async (id, data) => {
    return apiClient.patch(`/main/api/admin/marketing/assets/${id}`, data);
  },
  remove: async (id) => {
    await apiClient.delete(`/main/api/admin/marketing/assets/${id}`);
  },
  /** Upload a hero image (multipart) → permanent public URL. */
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post("/main/api/admin/marketing/images", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  getAnalytics: async (id, range) => {
    return apiClient.get(`/main/api/admin/marketing/assets/${id}/analytics`, { params: range });
  }
};

export {
  adminMarketingApi
};
